/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/control-has-associated-label */
import { useEffect, useState } from 'react';
import { Row, Col, Typography, Form, App, Input, Button, Skeleton } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import { ReactComponent as LogoNameDesc } from '../../Icons/LogoNameDesc.svg';
import cl from './footer.module.css';
import { ReactComponent as Telegram } from '../../Icons/Telegram.svg';
import { ReactComponent as Odnoklassniki } from '../../Icons/Odnoklassniki.svg';
import { ReactComponent as VK } from '../../Icons/VK.svg';
import { ReactComponent as YouTube } from '../../Icons/YouTube.svg';
import { CallUsRequest } from '../CallUsRequest';
import { useHttp } from '../../Hooks/Http.hook';
import articles from '../../Data/articles';

const Footer = () => {
    const [form] = Form.useForm();
    const [categories, setCategories] = useState([]);
    const [publications, setPublications] = useState({});
    const { notification } = App.useApp();
    const { request, loading } = useHttp(false);
    const navigate = useNavigate();

    const onFinish = () => {
        console.log('Запрос на рассылку');
        notification.info({ message: 'запрос на рассылку' });
    };

    useEffect(() => {
        const getAllCategories = async () => {
            await request('/api/category', 'GET')
                .then((res) => {
                    if (res.data) {
                        setCategories(res.data);
                    } else if (res.error) {
                        notification.error({ message: res.error.message });
                    }
                })
                .catch(() =>
                    notification.error({
                        message:
                            'Ошибка сервера. Попробуйте перезагрузить страницу.',
                    })
                );
        };

        const getPartners = async (el) => {
            await request(`/api/article/${el.key}?page1&perPage=10`, 'GET')
                .then((res) => {
                    if (res.data) {
                        setPublications((prev) => ({
                            ...prev,
                            [el.key]: {
                                data: res.data.articles ?? [],
                                title: el.title,
                            },
                        }));
                    } else if (res.error) {
                        notification.error({ message: res.error.message });
                    }
                })
                .catch(() =>
                    notification.error({
                        message:
                            'Ошибка сервера. Попробуйте перезагрузить страницу.',
                    })
                );
        };

        getAllCategories();

        articles.forEach(async (item) => {
            await getPartners(item);
        });
    }, []);

    const items = [
        {
            title: 'Высшее качество',
            icon: '/Images/Icon/fire.svg',
        },
        {
            title: 'Работа по договору',
            icon: '/Images/Icon/document.svg',
        },
        {
            title: 'Точное понимание потребностей клиента',
            icon: '/Images/Icon/place.svg',
        },
        {
            title: 'Быстрый поиск необходимого',
            icon: '/Images/Icon/time.svg',
        },
        {
            title: 'Доставка по всей России',
            icon: '/Images/Icon/shipping.svg',
        },
    ];

    return (
        <div className={cl.footer}>
            <Row className={cl.aboutUs}>
                <Row className={cl.aboutUsContent}>
                    {items.map((item) => (
                        <Col key={item.icon} className={cl.itemEl}>
                            <Col className={cl.itemContent}>
                                <img src={item.icon} alt="" />
                            </Col>
                            <Col className={cl.itemContent}>{item.title}</Col>
                        </Col>
                    ))}
                </Row>
            </Row>

            <Row className={cl.content}>
                <Row className={cl.wrapper}>
                    <div className={`${cl.block} ${cl.contacts}`}>
                        <Typography.Title
                            level={4}
                            className={cl.title}
                            style={{ textAlign: 'center' }}
                        >
                            Контакты
                        </Typography.Title>
                        <Typography.Paragraph>
                            г.Санкт-Петербург, ул.Ленина, д.15, к.1
                        </Typography.Paragraph>

                        <Typography.Paragraph copyable className={cl.phone}>
                            +7-(999)-666-55-33
                        </Typography.Paragraph>

                        <CallUsRequest
                            text="Обратный звонок"
                            style={{
                                margin: '20px auto 30px auto',
                                maxWidth: '100%',
                                width: '100%',
                                borderRadius: 50,
                            }}
                        />

                        <Row
                            justify="space-between"
                            style={{ width: '100%', gap: 10 }}
                        >
                            <a
                                href="/"
                                target="_blank"
                                className={cl.socialIcon}
                            >
                                <Telegram />
                            </a>
                            <a
                                href="/"
                                target="_blank"
                                className={cl.socialIcon}
                            >
                                <Odnoklassniki />
                            </a>
                            <a
                                href="/"
                                target="_blank"
                                className={cl.socialIcon}
                            >
                                <VK />
                            </a>
                            <a
                                href="/"
                                target="_blank"
                                className={cl.socialIcon}
                            >
                                <YouTube />
                            </a>
                        </Row>
                    </div>

                    <div className={cl.block}>
                        <Typography.Title level={4} className={cl.title}>
                            Популярные товары
                        </Typography.Title>
                        <div className={cl.footerLinkContainer}>
                            {categories.slice(0, 6).map((category) => (
                                <Link
                                    key={category.id}
                                    to={`/categories/${category.id}`}
                                    className={cl.footerLink}
                                >
                                    {category.name}
                                </Link>
                            ))}
                        </div>
                    </div>

                    <div className={`${cl.block} ${cl.contacts}`}>
                        <LogoNameDesc className={cl.logo} />
                        <p
                            style={{
                                borderBottom: '2px solid var(--primary-yellow)',
                                paddingBottom: 5,
                            }}
                        >
                            Реализуем строительные материалы оптом в
                            Санкт-Петербурге и Ленинградской области.
                        </p>
                        <p>
                            Доставляем товары по выгодным ценам благодаря
                            прямому сотрудничеству с производителями и
                            транспортными компаниями
                        </p>
                    </div>

                    <div className={cl.block}>
                        <Typography.Title level={4} className={cl.title}>
                            Другое
                        </Typography.Title>
                        {/* {publications
                            ? articles.map((item) => (
                                  <Skeleton.Button
                                      key={item.key}
                                      style={{ marginBottom: 20 }}
                                      size="large"
                                      shape="square"
                                      active
                                      block
                                  />
                              ))
                            : articles.map((item) => (
                                  <Row
                                      key={item.key}
                                      className={cl.footerLink}
                                      onClick={() => {
                                          navigate(`/publication/${item.id}`);
                                      }}
                                  >
                                      {item.title}
                                  </Row>
                              ))} */}
                        <div className={cl.footerLinkContainer}>
                            <Link
                                to="/publication/service"
                                className={cl.footerLink}
                            >
                                Услуги
                            </Link>
                            <Link
                                to="/publication/partner"
                                className={cl.footerLink}
                            >
                                Партнеры
                            </Link>
                            <Link
                                to="/publication/blog"
                                className={cl.footerLink}
                            >
                                Блог
                            </Link>
                        </div>
                    </div>
                </Row>
            </Row>

            <Row className={cl.mailingWrapper}>
                <div className={cl.mailingLeft}>
                    <Typography.Paragraph className={cl.mailingTitle}>
                        Подпишись на рассылку
                    </Typography.Paragraph>
                    <Typography.Paragraph className={cl.mailingDesc}>
                        Будьте в курсе лучших предложений
                    </Typography.Paragraph>
                </div>
                <Col span={19} className={cl.mailingContainer}>
                    <Form form={form} disabled={loading} onFinish={onFinish}>
                        <Form.Item
                            name="email"
                            validateDebounce={3000}
                            style={{
                                height: 50,
                            }}
                            rules={[
                                {
                                    type: 'email',
                                    message: '',
                                },
                                {
                                    required: true,
                                    message: '',
                                },
                                () => ({
                                    validator(_, value) {
                                        if (value?.trim().length > 0) {
                                            return Promise.resolve();
                                        }
                                        return Promise.reject(
                                            new Error(
                                                'Введите пожалуйста эл. почту'
                                            )
                                        );
                                    },
                                }),
                            ]}
                        >
                            <Input
                                style={{
                                    marginTop: '5px',
                                    height: 42,
                                    fontSize: 14,
                                }}
                                placeholder="example@mail.ru"
                            />
                        </Form.Item>
                        <Button
                            htmlType="submit"
                            type="primary"
                            size="middle"
                            className={cl.submitBtn}
                        >
                            Подписаться
                        </Button>
                    </Form>
                </Col>
            </Row>
        </div>
    );
};

export default Footer;
